/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PackingInitResVo } from './PackingInitResVo';
import {
    PackingInitResVoFromJSON,
    PackingInitResVoFromJSONTyped,
    PackingInitResVoToJSON,
    PackingInitResVoToJSONTyped,
} from './PackingInitResVo';

/**
 * 
 * @export
 * @interface ResponsePackingInitResVo
 */
export interface ResponsePackingInitResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePackingInitResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePackingInitResVo
     */
    message?: string;
    /**
     * 
     * @type {PackingInitResVo}
     * @memberof ResponsePackingInitResVo
     */
    data?: PackingInitResVo;
}

/**
 * Check if a given object implements the ResponsePackingInitResVo interface.
 */
export function instanceOfResponsePackingInitResVo(value: object): value is ResponsePackingInitResVo {
    return true;
}

export function ResponsePackingInitResVoFromJSON(json: any): ResponsePackingInitResVo {
    return ResponsePackingInitResVoFromJSONTyped(json, false);
}

export function ResponsePackingInitResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePackingInitResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PackingInitResVoFromJSON(json['data']),
    };
}

export function ResponsePackingInitResVoToJSON(json: any): ResponsePackingInitResVo {
    return ResponsePackingInitResVoToJSONTyped(json, false);
}

export function ResponsePackingInitResVoToJSONTyped(value?: ResponsePackingInitResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PackingInitResVoToJSON(value['data']),
    };
}

